module.exports = __webpack_public_path__ + "static/img/ddz-01.b5f2b7da.jpg";